import React from 'react';
import { ExternalLink } from 'lucide-react';

export const EnvironmentNotice = () => {
  const publicUrl = process.env.REACT_APP_PUBLIC_SITE_URL;
  const hosts = (process.env.REACT_APP_ANALYTICS_HOSTS || '').split(',').map(host => host.trim());
  const live = hosts.includes(window.location.hostname);
  return (
    <aside data-testid="admin-data-source" className={`flex flex-wrap items-center justify-between gap-3 px-4 py-3 text-xs border-b ${live ? 'bg-emerald-950 text-emerald-100 border-emerald-800' : 'bg-amber-50 text-amber-950 border-amber-200'}`}>
      <span data-testid="admin-data-source-label">{live ? 'Live omgeving · imperiaai.nl' : 'Testomgeving · deze cijfers zijn geen live klantstatistieken'}</span>
      {!live && publicUrl && <a data-testid="admin-open-live-statistics-link" href={`${publicUrl}/admin/traffic`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 underline font-semibold">Live statistieken <ExternalLink size={13} /></a>}
    </aside>
  );
};